import { memo, useCallback } from 'react';

import GuardianEventRow from '@/features/guardian/components/guardian-event-row';
import type { FamilyEvent } from '@/features/guardian/family-events';

export type CalendarListRowProps = {
  event: FamilyEvent;
  /** Draw a divider below this row (i.e. it isn't the last event of its day). */
  showDivider: boolean;
  onPress: (event: FamilyEvent) => void;
};

/**
 * One event inside a day's grouped card in the Calendar List view. Uses the shared
 * `agenda` row so same-day events read as a single card divided by hairlines — matching
 * the Family Agenda section rather than standalone cards per event.
 */
function CalendarListRow({ event, showDivider, onPress }: CalendarListRowProps) {
  const handlePress = useCallback(() => onPress(event), [event, onPress]);

  return (
    <GuardianEventRow
      accessibilityLabel={`${event.title} · ${event.playerName}`}
      accentColor={event.accentColor}
      playerAvatar={event.playerAvatar}
      playerName={event.playerName}
      title={event.title}
      variant="agenda"
      showDivider={showDivider}
      onPress={handlePress}
    />
  );
}

export default memo(CalendarListRow);
